"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const simpleId_1 = require("../../utilites/simpleId");
const cast_1 = require("../../utilites/cast");
const source_by_type_1 = require("../../utilites/source-by-type");
const AWSource_1 = require("./AWSource/AWSource");
const AWOutputVideo_1 = require("./AWOutputs/AWOutputVideo");
const AWOutputAudio_1 = require("./AWOutputs/AWOutputAudio");
class AWChannel {
    constructor(id) {
        this.id = '';
        this.source = null;
        this.outputs = {
            audio: [],
            video: []
        };
        this.order = 0;
        if (id) {
            this.id = id;
            this.source = new AWSource_1.AWSource();
        }
    }
    static from(object) {
        return cast_1.castToType(object, AWChannel);
    }
    static preset() {
        return new AWChannel(simpleId_1.simpleId());
    }
}
exports.AWChannel = AWChannel;
AWChannel.propFactory = {
    source: (object) => source_by_type_1.sourceByType(object),
    outputs: (object) => {
        return {
            audio: object.audio ? cast_1.castToArrayOfType(object.audio, AWOutputAudio_1.AWOutputAudio) : [],
            video: object.video ? cast_1.castToArrayOfType(object.video, AWOutputVideo_1.AWOutputVideo) : []
        };
    },
    setup: (object) => null
};
